export default __webpack_public_path__ + "static/media/no_data.d109774d.svg";